import script from "./LoadingOverlayComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingOverlayComponent.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingOverlayComponent.vue?vue&type=style&index=0&id=bbda3116&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbda3116"]])

export default __exports__